import { mapToReceiptedItems } from '../pages/receive-manifest/details/detail.mapping';
import { ManifestProps, TripSheetProps } from '../datastore/tripSheets';
import { postReceipt } from '../api/postReceipt';

export type RetryInventoryTransferResult = {
  success: boolean;
  error?: string;
};

export async function retryInventoryTransfer({
  tripData,
  manifestId,
  asn
}: {
  tripData: TripSheetProps;
  manifestId: string;
  asn: string;
}): Promise<RetryInventoryTransferResult> {
  const leg = tripData.legs.find((l) => l.manifests.some((m) => m.id === manifestId));

  if (!leg) {
    return { success: false, error: 'Manifest not found in trip data' };
  }

  const originalManifest = leg.manifests.find((m) => m.id === manifestId);
  if (!originalManifest) {
    return { success: false, error: 'Manifest not found in trip data' };
  }

  const filteredManifest: ManifestProps = {
    ...originalManifest,
    ssccs: originalManifest.ssccs.map((s) => ({
      ...s,
      packages: s.packages.filter((p) => p.asn === asn)
    }))
  };

  const receiptItems = mapToReceiptedItems(filteredManifest) || [];

  if (receiptItems.length === 0) {
    return { success: false, error: `No receipt data found for ASN ${asn}` };
  }

  const payload = {
    id: crypto.randomUUID(),
    source: 'ftl',
    'detail-type': 'ftl_qm_retry_inventory_transfer',
    detail: {
      receiptItems,
      manifestId,
      tripId: tripData.id,
      asns: [asn]
    }
  };

  const response = await postReceipt(JSON.stringify(payload));

  if (response.error) {
    return { success: false, error: response.error };
  }

  return { success: true };
}
